import cx from 'classnames';
import React from 'react';
import styles from './divider.module.scss';

interface DividerProps {
  /*
   * Whether divider is vertical
   */
  vertical?: boolean;
  /**
   * Custom class name
   */
  className?: string;
  /**
   * Whether to include section border or not
   */
  includeSectionBorder?: boolean;
}

export const Divider: React.FC<DividerProps> = ({
  className,
  vertical,
  includeSectionBorder = true,
  ...restProps
}: DividerProps) => (
  <div
    className={cx(className, {
      [styles.includeSectionBorder]: includeSectionBorder,
      [styles.vertical]: vertical,
    })}
    {...restProps}
  />
);
